export const cardData = [
    {
      id: 1,
      title: "Running Shoes",
      amount:  59.99,
      image: "https://assets.adidas.com/images/w_600,f_auto,q_auto/44875d2b18984d7a86c5b55bd629bc0c_9366/JAUNTZA_SHOES_White_IU7900_01_standard.jpg",
    },
    {
      id: 2,
      title: "Casual T-Shirt",
      amount: 19.99,
      image: "https://us.shop.realmadrid.com/_next/image?url=https%3A%2F%2Flegends.broadleafcloud.com%2Fapi%2Fasset%2Fcontent%2FRMCFMZ0201-1.jpg%3FcontextRequest%3D%257B%2522forceCatalogForFetch%2522%3Afalse%2C%2522forceFilterByCatalogIncludeInheritance%2522%3Afalse%2C%2522forceFilterByCatalogExcludeInheritance%2522%3Afalse%2C%2522applicationId%2522%3A%252201H4RD9NXMKQBQ1WVKM1181VD8%2522%2C%2522tenantId%2522%3A%2522REAL_MADRID%2522%257D&w=1200&q=75",
    },
    {
      id: 3,
      title: "Comfort Slippers",
      amount: 29.99,
      image: "https://m.media-amazon.com/images/I/413tnZpD7ZL._SY695_.jpg",
    },
    {
      id: 4,
      title: "Sunglasses",
      amount: 49.99,
      image: "https://www.voyageeyewear.com/cdn/shop/files/3405MG3786-3_b01b7950-a630-4e4c-9231-c8de01d4f5fe.jpg?v=1721299230&width=800",
    },
    {
        id: 5,
        title: "Sports Watch",
        amount: 89.99,
        image: "https://media-ik.croma.com/prod/https://media.croma.com/image/upload/v1718021332/Croma%20Assets/Wearable/Wearable%20Devices/Images/306979_tpa58m.png?tr=w-100",
      },
  ];
  